import Api from "../utils/axios";


export const documentApi = {
    createDocument: (payload) => Api.post("master/create-document", payload,{
        headers: {
            "Content-Type": "multipart/form-data",
          },
    }),
    updateDocument: (payload, id) => Api.put(`master/update-document/${id}`, payload,{
        headers: {
            "Content-Type": "multipart/form-data",
          },
    }),
    getDocumentById: (id) => Api.get(`master/get-document/${id}`),
    getAllDocument: () => Api.get("master/get-all-document"),
    deleteDocument: (id) => Api.delete(`master/delete-document/${id}`)
  };

export const ticketApis = {
  createTicket: (payload) =>
    Api.post("user/create-ticket", payload),

  getAllTickets: (payload) =>
    Api.post("user/get-all-tickets", payload),

  getTicketStats: () =>
    Api.get("user/ticket-stats"),

  getTicketById: (id) =>
    Api.get(`user/ticket/${id}`),

  replyToTicket: ({ id, payload }) =>
    Api.post(`user/reply-to-ticket/${id}`, payload),

  updateTicketStatus: ({ id, payload }) =>
    Api.patch(`user/update-ticket-status/${id}`, payload),

  deleteTicket: (id) =>
    Api.delete(`user/ticket/${id}`),
};

export const bankDetailApi = {
    createBankDetail: (payload) => Api.post("vendor/create-bank-detail", payload,{
        headers: {
            "Content-Type": "multipart/form-data",
          },
    }),
    updateBankDetail: (payload, id) => Api.put(`vendor/update-bank-detail/${id}`, payload,{
        headers: {
            "Content-Type": "multipart/form-data",
          },
    }),
    getBankDetailById: (id) => Api.get(`vendor/get-bank-detail/${id}`),
    // getAllDocument: () => Api.get("master/get-all-document"),
    deleteBankDetail: (id) => Api.delete(`master/delete-document/${id}`)
  };
  export const AdminContectApi ={
    getAdminContect: () => Api.get("vendor/get-all-admin-logo-settings"),
  }

  export const ArticlesApi={
    getArticlesDetails: ()=>Api.get("vendor/get-all-privacy-terms"),
  }